export class TasksPermissions {
	see: boolean;
	add: boolean;

	constructor(
		see: boolean,
		add: boolean
	) {
		this.see = see;
		this.add = add;
	}
}

export const ownerTasksPermissions = new TasksPermissions( true, true );
export const projectManagerTasksPermissions = new TasksPermissions( true, true );
export const projectEditorTasksPermissions = new TasksPermissions( true, true );
export const projectReviewerTasksPermissions = new TasksPermissions( true, true );
export const projectLimitedEditorTasksPermissions = new TasksPermissions( true, true );
export const nullTasksPermissions = new TasksPermissions( false, false );
